"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LearnMoreLink = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
/* Simple wrapper around InteractiveLinkWidget to create a "learn more" link widget.
 * When clicked, it will open the provided help url in a new window/tab. */
var LearnMoreLink = /** @class */ (function (_super) {
    __extends(LearnMoreLink, _super);
    function LearnMoreLink(props) {
        var _this = _super.call(this, props) || this;
        _this.onLearnMoreLinkClicked = _this.onLearnMoreLinkClicked.bind(_this);
        return _this;
    }
    LearnMoreLink.prototype.onLearnMoreLinkClicked = function () {
        if (this.props.notifyOnClick) {
            this.props.notifyOnClick();
        }
        window.open(this.props.helpUrl, '_blank');
    };
    LearnMoreLink.prototype.render = function () {
        return (React.createElement(widgets_1.TextLinkWidget, { onClick: this.onLearnMoreLinkClicked, kind: widgets_1.TextLinkKind.Standard, testId: this.props.testId }, this.props.text));
    };
    return LearnMoreLink;
}(React.Component));
exports.LearnMoreLink = LearnMoreLink;
//# sourceMappingURL=LearnMoreLink.js.map